// extracted by mini-css-extract-plugin
module.exports = {"toPriceSelect":"price_toPriceSelect__SFxGE","errorBox":"price_errorBox__FPicJ"};